import {
  ITags,
  TicketTagsState,
} from "app/containers/Features/components/CommonTagSelection/types";
import { fixedTagsColorCode } from "../data";

const defaultTagsForm: ITags = {
  _id: "",
  color: fixedTagsColorCode[5],
  title: "",
  projectId: "",
  createdAt: "",
  createdBy: "",
  isArchived: false,
  updatedAt: "",
};
  
export const initialState: TicketTagsState = {
  form: defaultTagsForm,
  loading: false,
  deleteModal: false,
  selectedId: "",
  buttonLoading: false
};
